import Vue from 'vue';

const FEATURE_SWITCHES_ENV_VARIABLES_PREFIX = 'VUE_APP_FEATURE_SWITCH_';
const MODULE_PREFIX = 'featureSwitches';
const GETTER_NEWSPAPER_V2 = 'newspaper_v2';
const GETTER_ADVANCED_SEARCH = 'advancedSearch';
const GETTER_VERTICAL_SPLIT_SECTION_CREATOR = 'verticalSplitSectionCreator';
const MUTATION_NEWSPAPER_V2 = 'NEWSPAPER_V2';
const MUTATION_USER_SWITCH_UPDATE = 'userSwitchUpdate';
const ACTION_INIT_FEATURE_SWITCHES = 'initFeatureSwitches';
const ACTION_FIRESTORE_USER_SWITCHES = 'firestoreUserSwitches';
const GETTER_PIPELINED_JOURNAL = 'getterPipelinedJournal';

const initialState = {
  newspaper_v2: false,
  pipelinedJournal: true,
  advancedSearch: false,
  user: {},
};

const mutations = {
  [MUTATION_NEWSPAPER_V2]: (state, envValue) => {
    state.newspaper_v2 = envValue === true || envValue === 'true';
  },
  [MUTATION_USER_SWITCH_UPDATE]: (state, { key, value }) => {
    Vue.set(state.user, key, value);
  },
};


const actions = {
  [ACTION_INIT_FEATURE_SWITCHES]: async ({ commit, getters }, envVariables) => {
    Object.keys(envVariables)
      .filter(envKey => envKey.startsWith(FEATURE_SWITCHES_ENV_VARIABLES_PREFIX))
      .map(envKey => envKey.replace(FEATURE_SWITCHES_ENV_VARIABLES_PREFIX, '').toLowerCase())
      .filter(featureSwitchKey => Object.keys(getters).includes(featureSwitchKey))
      .forEach(featureSwitchKey => {
        commit(
          featureSwitchKey.toUpperCase(),
          envVariables[FEATURE_SWITCHES_ENV_VARIABLES_PREFIX + (featureSwitchKey.toUpperCase())],
        );
      });
  },
  [ACTION_FIRESTORE_USER_SWITCHES]: ({ commit }, userSwitches) => {
    Object.keys(userSwitches).forEach(key =>
      commit(MUTATION_USER_SWITCH_UPDATE, { key, value: userSwitches[key] }));
  },
};

const getSwitch = (state, featureName) => {
  if (state.user[featureName] !== undefined) {
    return state.user[featureName];
  }

  return state[featureName];
};

const getters = {
  [GETTER_NEWSPAPER_V2]: state => state.newspaper_v2,
  [GETTER_PIPELINED_JOURNAL]: state => getSwitch(state, 'pipelinedJournal'),
  [GETTER_ADVANCED_SEARCH]: state => getSwitch(state, 'advancedSearch'),
  [GETTER_VERTICAL_SPLIT_SECTION_CREATOR]: state => getSwitch(state, 'verticalSplitSectionCreator'),
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export const types = {
  getters: {
    newspaper_v2: `${MODULE_PREFIX}/${GETTER_NEWSPAPER_V2}`,
    pipelinedJournal: `${MODULE_PREFIX}/${GETTER_PIPELINED_JOURNAL}`,
    advancedSearch: `${MODULE_PREFIX}/${GETTER_ADVANCED_SEARCH}`,
    verticalSplitSectionCreator: `${MODULE_PREFIX}/${GETTER_VERTICAL_SPLIT_SECTION_CREATOR}`,
  },
  actions: {
    initFeatureSwitches: `${MODULE_PREFIX}/${ACTION_INIT_FEATURE_SWITCHES}`,
    firestoreUserSwitches: `${MODULE_PREFIX}/${ACTION_FIRESTORE_USER_SWITCHES}`,
  },
};
